import React, { FC, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as ArrowCircleRight } from '../../../icons/arrow-right-circle.svg';
import api from '../../../api';
import { OnboardingStepProps } from '../OnboardingFlow';
import './assistant-setup-step.scss';

interface AssistantSetupStepProps extends OnboardingStepProps {
  /** Domain-setup workflow ID returned by /finalize-assistant (kept for compat) */
  workflowId: string | null;
}

const AssistantSetupStep: FC<AssistantSetupStepProps> = ({ refreshStatus }) => {
  const { getAccessTokenSilently } = useAuth0();

  const handleNext = useCallback(async () => {
    try {
      const token = await getAccessTokenSilently();
      await api.post(
        '/onboarding/complete-assistant-setup',
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      sessionStorage.removeItem('onboarding_email_workflow_id');
      await refreshStatus();
    } catch (err) {
      console.error('[AssistantSetup] Failed to complete step:', err);
    }
  }, [getAccessTokenSilently, refreshStatus]);

  return (
    <div className='onboarding-step assistant-setup-step'>
      <div className='setup-left'>
        <h1 className='setup-title'>Meet your powerful, personal assistant</h1>
        <div className='setup-description'>
          <p>
            It's time to get me setup. I can do almost everything to reduce your
            workload; research and planning, messaging people, and even buying
            things for you. With my team of Dreamsters I can even do things in
            the real world.
          </p>
          <p>Let's start by connecting your email and calendar.</p>
        </div>
        <div className='setup-actions'>
          <button className='step-button' onClick={handleNext}>
            Next
            <ArrowCircleRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssistantSetupStep;
